// extracted by mini-css-extract-plugin
export var readonly = "_i4-1";
export var star = "_i4-0";